import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
    }

    show() {
        this.el.classList.add('is-active')
    }

    close() {
        this.el.classList.remove('is-active')
    }
}
